"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _assertBadHttpStatus = require("./assertBadHttpStatus");
Object.keys(_assertBadHttpStatus).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _assertBadHttpStatus[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _assertBadHttpStatus[key];
    }
  });
});